import React from 'react';

interface SiteFooterProps {
  variant: 'home' | 'catalog';
  getContent: (key: string) => string;
}

// Template footer. The brand text mirrors the header's editable keys but stays
// read-only here so each content key has a single editor instance (the header).
const SiteFooter: React.FC<SiteFooterProps> = ({ variant, getContent }) => {
  const title = getContent('company-title');
  const titleEn = getContent('company-title-en');
  return (
    <footer>
      <a className="brand" href={variant === 'home' ? '#home' : '/'}>
        {title}
        <small>{titleEn}</small>
      </a>
      <span>
        © {new Date().getFullYear()} {title} {titleEn}
      </span>
      {variant === 'home' ? <a href="#home">返回頂端 ↑</a> : <a href="/">返回首頁 ↗</a>}
    </footer>
  );
};

export default SiteFooter;
